<template>
    <div id="home-page">
        <section-video></section-video>
        <section-why-ujv></section-why-ujv>
        <section-featured-hotels></section-featured-hotels>
        <!--<section-quotes-partners></section-quotes-partners>-->
        <!--<section-app></section-app>-->
        <!--<section-ujv-process></section-ujv-process>-->
        <!--<section-featured-posts></section-featured-posts>-->
        <!--<section-awards-instagram></section-awards-instagram>-->
        <!--<section-important-documents></section-important-documents>-->
        <section-our-programs></section-our-programs>
        <section-marketing></section-marketing>
        <section-affiliated-partners></section-affiliated-partners>
        <!--<testimonies-container></testimonies-container>-->
        <section-our-clients-say></section-our-clients-say>
    </div>
</template>

<script>
    import SectionVideo from '../components/sections/Video';
    import SectionWhyUjv from '../components/sections/WhyUjv';
    import SectionFeaturedHotels from '../components/sections/FeaturedHotels';
    import SectionQuotesPartners from '../components/sections/QuotesPartners';
    import SectionApp from '../components/sections/App';
    import SectionAppSmall from '../components/sections/AppSmall';
    import SectionFeaturedPosts from '../components/sections/FeaturedPosts';
    //import SectionUjvProcess from '../components/sections/UjvProcess';
    import SectionSubscribeToNewsletter from '../components/sections/SubscriteToNewsletter';
    import SectionAwardsInstagram from '../components/sections/AwardsInstagram';
    import SectionSocialMedia from '../components/sections/SocialMedia';
    import SectionImportantDocuments from '../components/sections/ImportantDocuments';
    import SectionOurPrograms from '../components/sections/OurPrograms';
    import SectionMarketing from '../components/sections/Marketing';
    import SectionAffiliatedPartners from '../components/sections/AffiliatedPartners';
    import TestimoniesContainer from "../components/data-containers/TestimoniesContainer";
    import SectionOurClientsSay from '../components/sections/OurClientsSay';

    export default {
        components: {
            SectionVideo, SectionWhyUjv, SectionFeaturedHotels,
            SectionQuotesPartners, SectionApp, SectionAppSmall,
            SectionFeaturedPosts, SectionAwardsInstagram,
            SectionSocialMedia, SectionImportantDocuments, SectionMarketing, SectionAffiliatedPartners,
            TestimoniesContainer, SectionOurClientsSay, SectionOurPrograms
        },
    }

</script>

<style lang="scss">
    /** Unique Index Styles **/
</style>
